import { RbacPermission } from '~/types/Rbac';

import { useAllPermissionsQuery } from './useAllPermissionsQuery';

type Props = {
  permission?: RbacPermission;
};

export const usePermission = ({ permission }: Props) => {
  const { data, isFetching, isUninitialized } = useAllPermissionsQuery();

  if (!permission) {
    return { hasPermission: true, isLoading: false };
  }

  // Unresolved has to read as loading, never as denied — same rule
  // `usePermissions` follows. An entry nobody has dispatched for yet is
  // `isUninitialized`, which `isFetching` alone misses.
  return {
    hasPermission: data?.[permission.resourceId]?.[permission.resourceType],
    isLoading: isUninitialized || isFetching,
  };
};
